import { Link } from "react-router-dom";
import { reopenCookieBanner } from "@/components/CookieBanner";

const LINKS = [
  ["/mentions-legales", "Mentions légales", "footer-legal-link"],
  ["/confidentialite", "Confidentialité", "footer-privacy-link"],
  ["/cgu-cgv", "CGU / CGV", "footer-terms-link"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-10 border-t-2 border-[color:var(--line)] bg-[color:var(--paper-2)]/60">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-8 text-sm sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <p className="font-bold">Lis-Moi · Sans publicité · Sans suivi publicitaire</p>
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          {LINKS.map(([to, label, id]) => (
            <Link key={to} to={to} data-testid={id} className="font-semibold underline-offset-4 hover:underline">{label}</Link>
          ))}
          <button data-testid="footer-cookies-button" onClick={reopenCookieBanner} className="font-semibold underline-offset-4 hover:underline">Gérer les cookies</button>
        </nav>
      </div>
    </footer>
  );
}
